/**
 * Get the base domain for district subdomains.
 * e.g. smartmarketing.backtoschoolforms.com -> backtoschoolforms.com
 *      backtoschoolforms.com -> backtoschoolforms.com
 * Legacy: smartmarketing.backtoschool.smdemo.website -> backtoschool.smdemo.website
 */
export const getBaseDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('localhost')) return 'backtoschoolforms.com'; // dev fallback for district URL hints

  const parts = hostname.split('.');

  // *.backtoschoolforms.com (e.g. district or www)
  if (hostname.endsWith('.backtoschoolforms.com') && parts.length >= 3) {
    return 'backtoschoolforms.com';
  }

  // Legacy 4+ label hostnames (e.g. district.backtoschool.smdemo.website)
  if (parts.length >= 4) return parts.slice(1).join('.');

  return hostname;
};

/**
 * Build district URL for a given subdomain
 * e.g. getDistrictUrl('smartmarketing') -> https://smartmarketing.backtoschoolforms.com
 */
export const getDistrictUrl = (subdomain) => {
  const base = getBaseDomain();
  return `${window.location.protocol}//${subdomain}.${base}`;
};
